import { useEffect } from "react";
import { Link } from "react-router-dom";
import "./ServiceDetail.css";

const SolarService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const services = [
    {
      title: "Residential Solar",
      items: [
        "Home Solar Systems",
        "Smart Home Integration",
        "Rooftop Installation",
        "Battery Storage",
      ],
    },
    {
      title: "Commercial Solar",
      items: [
        "Business Power Solutions",
        "Large-Scale Installation",
        "Energy Management",
        "Grid-Tie Systems",
      ],
    },
    {
      title: "Installation & Setup",
      items: [
        "Professional Installation",
        "System Testing",
        "Safety Compliance",
        "User Training",
      ],
    },
    {
      title: "Maintenance & Support",
      items: [
        "Regular Servicing",
        "Performance Monitoring",
        "Repairs & Upgrades",
        "24/7 Support",
      ],
    },
  ];

  return (
    <div className="service-detail-page">
      <section className="service-detail-hero">
        <div className="hero-particles"></div>
        <div className="container">
          <Link to="/services" className="back-link">
            ← Back to Services
          </Link>
          <div className="service-detail-hero-content">
            <div className="service-icon-hero">☀️</div>
            <h1>Solar Energy Solutions</h1>
            <p>
              Clean, reliable power that guarantees you never lack energy for
              your upgraded lifestyle
            </p>
          </div>
        </div>
      </section>

      <section className="service-overview">
        <div className="container">
          <div className="overview-grid">
            <div className="overview-content">
              <h2>Power Your Lifestyle With Clean Energy</h2>
              <p>
                We provide smart homes fitted with customized solar solutions
                that reduce your energy costs while giving you complete energy
                independence. Our systems are designed for your specific needs,
                ensuring optimal performance and reliability.
              </p>
              <p>
                From consultation to installation and ongoing maintenance, we
                handle everything to make your transition to solar seamless.
              </p>
            </div>
            <div className="overview-stats">
              <div className="stat-item">
                <div className="stat-number">200+</div>
                <div className="stat-label">Installations</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">100%</div>
                <div className="stat-label">Clean</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="service-programs">
        <div className="container">
          <h2>Our Services</h2>
          <div className="programs-grid">
            {services.map((service, index) => (
              <div key={index} className="program-item">
                <h3>{service.title}</h3>
                <ul className="program-topics">
                  {service.items.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="service-detail-cta">
        <div className="container">
          <h2>Ready to Go Solar?</h2>
          <p>Start saving money and living sustainably today</p>
          <Link to="/contact-us" className="btn btn-light">
            Get a Quote
          </Link>
        </div>
      </section>
    </div>
  );
};

export default SolarService;
